<template>
  <div class="fang-song px-14 pt-26">
    <div class="my-16 mx-auto text-2xl text-center font-heiti">报告声明</div>
    <div class="text-segment font-heiti">1、评测依据</div>
    <p>
      本报告依据工信部《中小企业数字化水平评测指标（2024
      年版）》（工信厅企业〔2024〕56
      号），从数字化基础、数字化管理、数字化成效和数字化经营四个维度对中小企业数字化水平进行综合评测。
    </p>
    <div class="text-segment font-heiti pt-5">2、评测方法</div>
    <p>
      评测机构受吉林市工业和信息化局委托，参照《中小企业数字化转型试点城市试点企业数字化水平评测指南（2024
      年版）》（工企业函〔2024〕239号）开展评测工作。试点企业登录吉林市中小企业数字化水平评测服务系统（网址https://dtms.mesync.cn）提交相关信息及佐证材料，评测机构以线上和现场相结合的方式完成评测工作。
    </p>
    <div class="text-segment font-heiti pt-5">3、报告使用范围</div>
    <p>
      本报告依据企业当次填报信息并结合现场评测出具，旨在帮助企业了解自身的数字化水平，识别数字化转型中的优势与不足，助力试点企业坚定数字化转型方向。本报告使用范围及最终解释权归吉林市工业和信息化局所有。
    </p>
  </div>
</template>

<script>
// 声明
export default {
  props: ["info"],
};
</script>
